export const transformGroupByResToList = (data: any) => {
  let eventList: any[] = [];
  if (data) {
    const recentlyUsed: any[] = [];
    data.forEach((group) => {
      if (group.group === 'Recently Used') {
        group.events.forEach((event) => {
          recentlyUsed.push({ ...event, is_recently_used: true });
        });
      } else if (group.group === 'Raw Events') {
        group.events.forEach((event) => {
          // has_duplicate_name means already have a mapped event name same with this raw event.
          if (event?.has_duplicate_name === false) {
            eventList.push({ ...event, is_raw: true });
          }
        });
      } else {
        eventList = [...eventList, ...group.events];
      }

      // remove duplicate events from recently used and raw events
      const uniqueEventList = eventList.filter((event) => {
        return recentlyUsed.find((i) => i.id === event.id || i.name === event.name) === undefined;
      });

      eventList = [...recentlyUsed, ...uniqueEventList];
    });
  }

  eventList.forEach((event) => {
    // for keep consistent with mapped events API
    event['event_id'] = event.id;
    event['event_name'] = event.name;
    event['event_category'] = event.category_name;
  });
  return eventList;
};
